import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar/Navbar';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { FaEdit } from 'react-icons/fa';
import "./Client/ClientDetails.css";
import { getHolidayList, holidayListupdate } from '../../Redux/Auth/Action';
import NewDataTable from '../DataTable/NewDataTable';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import { FaTrash } from "react-icons/fa";


const Holiday = () => {
    const [show, setShow] = useState(false);
    const dispatch = useDispatch();
    const token = localStorage.getItem("token");
    const loginId = localStorage.getItem("loginId");
    const { holidaylist } = useSelector((store) => store.auth);

    const [formData, setFormData] = useState({
        holidayCalenderId: "",
        occasion: "",
        date: "",
        day: "",
        actionType: "INSERT"
    });

    const clearUserInputFields = () => {
        setFormData(
            {
                holidayCalenderId: "",
                occasion: "",
                date: "",
                day: "",
                actionType: "INSERT"
            },
        );
    };

    const handleClose = () => {
        clearUserInputFields();
        setShow(false);
    };

    useEffect(() => {
        dispatch(getHolidayList(token));
    }, [dispatch, token]);

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();

        const result = await Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, submit it!",
            cancelButtonText: "No, cancel",
        });
        if (result.isConfirmed) {
            dispatch(holidayListupdate(formData, token))
                .then((response) => {
                    if (response.statusCode === "00") {
                        dispatch(getHolidayList(token));
                        handleClose();
                        Swal.fire({
                            title: "Success!",
                            text: response.statusDesc,
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.error,
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "Error!",
                        text: "Something went wrong. Please try again later.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                })
        }
    };

    const handleHolidayEdit = (data, action) => {
        setFormData({
            holidayCalenderId: data.holidayCalenderId,
            occasion: data.occasion,
            date: data.date,
            day: data.day,
            actionType: action

        });
        if (action === "UPDATE") {
            setShow(true);
        }

    }

    useEffect(() => {
        if (formData.actionType === "DELETE") {
            handleSubmit();
        }
    }, [formData.actionType]);

    const columns = [
        {
            name: "SN",
            cell: (_, index) => index + 1,
            sortable: false,
            width: "80px",
            align: "center",
        },
        {
            name: "Date",
            selector: (row) => format(row?.date, "dd-MM-yyy") || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Week Day",
            selector: (row) => row?.day || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Occasion",
            selector: (row) => row?.occasion || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Action",
            selector: (row) => row,
            sortable: false,
            align: "center",
            cell: (row) => (
                <>
                    <Tooltip text="Edit">
                        <FaEdit
                            className="text-warning me-3" size={20}
                            onClick={() => handleHolidayEdit(row, "UPDATE")}
                        />
                    </Tooltip>
                    <Tooltip text="Delete">
                        <FaTrash
                            className="cursor-pointer text-danger" size={16}
                            onClick={() => handleHolidayEdit(row, "DELETE")}
                        />
                    </Tooltip>
                </>

            ),

        },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleDateChange = (date, name) => {
        if (!date) {
            setFormData((prev) => ({
                ...prev,
                [name]: null,
                day: ""
            }));
            return;
        }
        const weekDay = date.toLocaleDateString("en-IN", {
            weekday: "long"
        });

        setFormData((prev) => ({
            ...prev,
            [name]: date,
            day: weekDay
        }));
        setFormData((prevData) => {
            let updatedData = {
                ...prevData,
                [name]: date ? format(date, "yyyy-MM-dd") : "",
            };
            return updatedData;
        })
    }

    const Tooltip = ({ text, children }) => {
        return (
            <div className="tooltip-container">
                {children}
                <div className="tooltip">{text}</div>
            </div>
        );
    };

    return (
        <div>
            <Navbar />

            <div className="main-content">
                <div className="container-fluid mt-4">
                    <div>
                        <div>
                            <NewDataTable
                                columns={columns}
                                data={holidaylist || []}
                                tableName="HOLIDAYS"
                                totalRecord={holidaylist?.length ?? 0}
                            />
                            <div className="text-center">
                                <button
                                    type="button"
                                    className="btn btn-primary fw-bold mt-3"
                                    onClick={() => setShow(true)}
                                >
                                    ADD
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`modal leave-modal ${show ? "d-block" : "d-none"}`}
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{`${formData.actionType === "INSERT" ? "Add" : "Update"} Holiday Data`}</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={handleClose}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row mb-3">
                                    <div className="col-md-4">
                                        <label htmlFor="date" className="form-label">
                                            Date <span className="text-danger">*</span>
                                        </label>
                                        <DatePicker
                                            selected={formData.date ? new Date(formData.date) : null}
                                            onChange={(date) => handleDateChange(date, "date")}
                                            className="form-control"
                                            dateFormat="dd-MM-yyyy"
                                            placeholderText=" Date"
                                            showYearDropdown
                                            showMonthDropdown
                                            dropdownMode="select"
                                            onKeyDown={(event) => event.preventDefault()}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="day" className="form-label">
                                            Week Day <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="day"
                                            className="form-control"
                                            name="day"
                                            value={formData.day}
                                            readOnly
                                            style={{ backgroundColor: "#ebe4e4ce" }}
                                        />

                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="occasion" className="form-label">
                                            Occasion <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="occasion"
                                            className="form-control"
                                            name="occasion"
                                            value={formData.occasion}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            required
                                        />
                                    </div>

                                </div>
                                <div className="text-center">
                                    <button type="submit" className={`btn ${formData.actionType === "INSERT" ? "btn-success" : "btn-warning"} mt-3`}>
                                        {`${formData.actionType === "INSERT" ? "SUBMIT" : "UPDATE"}`}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Holiday;